"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedSigner = exports.signerFromKeys = void 0;
var ethers_1 = require("ethers");
exports.signerFromKeys = function (keys) { return new ethers_1.ethers.Wallet(keys.privateKey); };
var ConnectedSigner = /** @class */ (function (_super) {
    __extends(ConnectedSigner, _super);
    function ConnectedSigner(signer, provider) {
        var _this = _super.call(this) || this;
        _this.signer = signer;
        var signerProto = Object.getPrototypeOf(signer);
        for (var _i = 0, _a = Object.keys(signerProto); _i < _a.length; _i++) {
            var propName = _a[_i];
            var propDesc = Object.getOwnPropertyDescriptor(signerProto, propName);
            var value = propDesc.value, get = propDesc.get;
            if ((typeof value === 'function' || typeof get === 'function') && propName !== 'constructor') {
                Object.defineProperty(_this, propName, Object.getOwnPropertyDescriptor(signerProto, propName));
            }
        }
        for (var _b = 0, _c = Object.entries(signer); _b < _c.length; _b++) {
            var _d = _c[_b], propName = _d[0], prop = _d[1];
            if (propName !== 'provider') {
                Object.defineProperty(_this, propName, { value: prop });
            }
        }
        _this.provider = provider;
        return _this;
    }
    ConnectedSigner.prototype.getAddress = function () {
        return this.signer.getAddress.bind(this)();
    };
    ConnectedSigner.prototype.sendTransaction = function (tx) {
        return this.signer.sendTransaction.bind(this)(tx);
    };
    ConnectedSigner.prototype.signMessage = function (msg) {
        return this.signer.signMessage.bind(this)(msg);
    };
    return ConnectedSigner;
}(ethers_1.ethers.Signer));
exports.ConnectedSigner = ConnectedSigner;
//# sourceMappingURL=signers.js.map